import { useEffect, useState } from 'react';
import { Alert, Box, CircularProgress, LinearProgress, Sheet, Stack, Typography } from '@mui/joy';
import { APIAdsCapacity } from '../../api_ads';
import { formatInt } from './adsConstants';

/**
 * Загрузка территории для выбранного города/региона: свободно, занято,
 * заполняемость. Запрашивает ёмкость сама при изменении территории.
 */
export default function AdCapacityCard({ token, city = null, region = null }) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let alive = true;
        setLoading(true);
        APIAdsCapacity(token, { city, region })
            .then((r) => { if (alive) setData(r); })
            .catch(() => { if (alive) setData(null); })
            .finally(() => { if (alive) setLoading(false); });
        return () => { alive = false; };
    }, [token, city, region]);

    if (loading) {
        return (
            <Sheet variant="outlined" sx={{ p: 2, borderRadius: 'md', mt: 2 }}>
                <Stack alignItems="center"><CircularProgress size="sm" /></Stack>
            </Sheet>
        );
    }
    const cap = data?.capacity;
    if (!cap) return null;

    const color = cap.fill_percent >= 100 ? 'danger' : cap.fill_percent >= 70 ? 'warning' : 'success';
    return (
        <Sheet variant="outlined" sx={{ p: 2, borderRadius: 'md', mt: 2 }}>
            <Typography level="title-sm" sx={{ mb: 1 }}>
                Загрузка территории: {city || region}
            </Typography>
            <Stack direction="row" spacing={2} flexWrap="wrap" sx={{ mb: 1 }}>
                <Box>
                    <Typography level="body-xs" color="neutral">Свободно/сут</Typography>
                    <Typography level="body-sm">{formatInt(cap.free_per_day)}</Typography>
                </Box>
                <Box>
                    <Typography level="body-xs" color="neutral">Занято/сут</Typography>
                    <Typography level="body-sm">{formatInt(cap.committed_per_day)}</Typography>
                </Box>
            </Stack>
            <Stack direction="row" justifyContent="space-between">
                <Typography level="body-xs">Заполняемость</Typography>
                <Typography level="body-xs" sx={{ fontWeight: 600 }}>{cap.fill_percent}%</Typography>
            </Stack>
            <LinearProgress determinate value={Math.min(100, cap.fill_percent)} color={color} sx={{ mb: 1 }} />
            {cap.fill_percent >= 100 && (
                <Alert color="danger" size="sm">
                    Свободного трафика почти нет — бюджет может не открутиться полностью.
                </Alert>
            )}
        </Sheet>
    );
}